/**
 * „Offene Transporte"-Tab (Jul-2026, User-Wunsch).
 *
 * Zeigt die offenen Transporte des Betriebs. Klick öffnet die Disposition.
 * Datenquelle: GET /api/dealer/transports/open → { items }.
 */
import { useEffect, useState } from "react";
import { Loader2, Truck, ArrowRight } from "lucide-react";
import api from "../../lib/api";

export default function MyOpenTransportsTab() {
    const [items, setItems] = useState(null);

    useEffect(() => {
        let on = true;
        api.get("/dealer/transports/open")
            .then((r) => { if (on) setItems(r.data?.items || []); })
            .catch(() => { if (on) setItems([]); });
        return () => { on = false; };
    }, []);

    if (items === null) {
        return <div className="p-6 flex items-center gap-2 text-gray-500 text-sm" data-testid="my-transports-loading"><Loader2 className="w-4 h-4 animate-spin" /> Lade Transporte…</div>;
    }
    if (items.length === 0) {
        return <div className="bg-white border border-gray-200 rounded-sm p-6 text-sm text-gray-500" data-testid="my-transports-empty">Keine offenen Transporte.</div>;
    }

    return (
        <div className="bg-white border border-gray-200 rounded-sm divide-y divide-gray-100" data-testid="my-transports-tab">
            {items.map((tr) => (
                <button
                    key={tr.id}
                    type="button"
                    onClick={() => window.open("/dealer/disposition", "_blank", "noopener")}
                    className="w-full flex items-center gap-3 px-3 py-2.5 text-left hover:bg-gray-50 transition-colors"
                    data-testid={`my-transport-row-${tr.id}`}
                >
                    <Truck className="w-4 h-4 text-[#FFCC00] shrink-0" />
                    <div className="min-w-0 flex-1">
                        <div className="font-bold text-sm text-[#111827] truncate">{tr.vehicle_label || "Fahrzeug"}</div>
                        <div className="text-xs text-gray-500">
                            {tr.status}
                            {(tr.from_city || tr.to_city) ? ` · ${[tr.from_city, tr.to_city].filter(Boolean).join(" → ")}` : ""}
                        </div>
                    </div>
                    <ArrowRight className="w-4 h-4 text-gray-400 shrink-0" />
                </button>
            ))}
        </div>
    );
}
